import { z } from 'zod';
export const DataExportRequestRequest = z.object({});
export const DataExportJobStatus = z.enum(['queued', 'running', 'completed', 'failed', 'expired']);
export const DataExportRequestResponse = z.object({
    job_id: z.string(),
    requested_at: z.string(),
    estimated_ready_at: z.string(),
    status: DataExportJobStatus,
});
export const DataExportStatusRequest = z.object({
    job_id: z.string(),
});
export const DataExportStatusResponse = z.object({
    job_id: z.string(),
    status: DataExportJobStatus,
    download_url: z.string().nullable(),
    download_expires_at: z.string().nullable(),
    size_bytes: z.number().int().nullable(),
});
export const AccountDeleteRequestRequest = z.object({
    reason: z.string().max(500).optional(),
    confirm_irreversible: z.literal(true),
});
export const AccountDeleteRequestResponse = z.object({
    job_id: z.string(),
    scheduled_at: z.string(),
    cancelable_until: z.string(),
});
export const AccountDeleteCancelRequest = z.object({
    job_id: z.string(),
});
export const AccountDeleteCancelResponse = z.object({
    ok: z.literal(true),
});
export const ConsentSnapshot = z.object({
    data_processing_consent: z.boolean(),
    marketing_consent: z.boolean(),
    personalized_ads_consent: z.boolean(),
    age_confirmed_17_plus: z.boolean(),
    consented_at: z.string(),
});
export const ConsentGetResponse = ConsentSnapshot;
export const ConsentUpdateRequest = ConsentSnapshot.partial().omit({ consented_at: true });
export const ConsentUpdateResponse = ConsentSnapshot;
//# sourceMappingURL=privacy.js.map